<template>
    <AppLayout>
        <AppHeader />
        <router-view />
        <AppFooter />
    </AppLayout>
</template>
